module.exports = ":host{display:block;height:var(--lui-line-height)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-breadcrumb/theme/lui-breadcrumb.scss
// module id = 170
// module chunks = 0 1 11